module.exports = __webpack_public_path__ + "static/media/flag-hmn.aa2e41ae.webp";